import { API_URL, requestData } from "./utils";

export default class InvoicesModule {
  getConnectionUrl() {
    return window.location.origin.toString() + "/api/xero/connect";
  }
  disconnect() {
    return requestData("DELETE", "/xero/disconnect");
  }
  generateInvoices(params, abortSignal) {
    return requestData(
      "GET",
      "/generate_enterprise_invoices",
      params,
      undefined,
      abortSignal
    );
  }
  generateResellerInvoices(params, abortSignal) {
    return requestData(
      "GET",
      "/generate_reseller_invoices",
      params,
      undefined,
      abortSignal
    );
  }
  getInvoice(params, abortSignal) {
    return requestData("GET", "/enterprise_invoice", params, undefined, abortSignal);
  }
  /**
   * Get a list of generated invoices,
   * @param {string} enterprise_id
  //  * @param {string} entity_id
   * @param {string} billing_account_id
   * @param {string} from_date
   * @param {string} to_date
   */
  getEnterpriseInvoicesHistoric(params, abortSignal) {
    return requestData(
      "GET",
      "/get_enterprise_invoices_historic",
      params,
      undefined,
      abortSignal
    );
  }

  getInvoicePDF(params, abortSignal) {
    return requestData(
      "GET",
      "/enterprise_invoice_pdf",
      params,
      {
        Accept: "application/pdf",
        "Content-Type": "application/pdf",
      },
      abortSignal
    );
  }
  getInvoiceRaw(params, abortSignal) {
    return requestData(
      "GET",
      "/enterprise_invoice_raw",
      params,
      {
        // Accept: "application/pdf",
        // "Content-Type": "application/pdf",
      },
      abortSignal
    );
  }
  editInvoice(data) {
    const { billing_account_id, year, month, line_item_type, description, price } =
      data;
    return requestData(
      "POST",
      `/invoice_adjustment/${billing_account_id}/${year}/${month}`,
      { invoice_adjustment: { line_item_type, description, price } }
    );
  }

  getBillingDetails(id) {
    return requestData("GET", `/billing_account/${id}`);
  }

  deleteInvoice(params) {
    const { enterprise_id, month, year } = params;
    return requestData(
      "DELETE",
      `/reset_enterprise_invoices?enterprise_id=${enterprise_id}&year=${year}&month=${month}`
    );
  }

  deleteInvoiceReseller(params) {
    const { reseller_id, month, year } = params;
    return requestData(
      "DELETE",
      `/reset_enterprise_invoices?reseller_id=${reseller_id}&year=${year}&month=${month}`
    );
  }

  resetInvoice(params) {
    const { enterprise_id, month, year } = params;
    return requestData(
      "GET",
      `/reset_invoices?enterprise_id=${enterprise_id}&year=${year}&month=${month}`
    );
  }

  resetInvoiceReseller(params) {
    const { reseller_id, month, year } = params;
    return requestData(
      "GET",
      `/reset_invoices?reseller_id=${reseller_id}&year=${year}&month=${month}`
    );
  }

  /**
   * Get a list of generated invoices,
   * @param {string} enterprise_id
   * @param {string} year
   * @param {string} month
   */
  getEnterpriseInvoicesList(params, abortSignal) {
    return requestData(
      "GET",
      "/get_enterprise_invoices_list",
      params,
      undefined,
      abortSignal
    );
  }

  getAdminInvoiceCsvURL(
    query,
    link = "/download_invoice",
  ) {
    return API_URL + link + "?" + new URLSearchParams(query);
  }
}
